import { useEffect, useState } from 'react';

/**
 * Returns the current timestamp in ms, updated every `tickMs` milliseconds.
 * Used to re-evaluate subscription expiry state reactively without a page reload.
 */
export function useSubscriptionClock(tickMs = 60_000): number {
  const [nowMs, setNowMs] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setNowMs(Date.now()), tickMs);
    return () => clearInterval(id);
  }, [tickMs]);

  return nowMs;
}
